// extracted by mini-css-extract-plugin
module.exports = {"root":"PublishButton_root__279a4"};